import Vue from 'vue';
import {
	message,
	notification,
	Button,
	Layout,
	Row,
	Col,
	Menu,
	Icon,
	Breadcrumb,
	Table,
	Pagination,
	Tag,
	Divider,
	ConfigProvider,
	DatePicker,
	Skeleton,
	FormModel,
	Input,
	Select,
	Switch,
	Checkbox,
	Radio,
	BackTop,
	Avatar,
	Dropdown,
	Form,
	Popconfirm,
	Drawer,
	Slider,
	Cascader,
	Spin,
	Upload,
	Steps,
	TimePicker,
	Progress,
	Modal,
	Timeline,
	Tabs,
	Statistic,
	Popover,
	List,
	Empty,
	Descriptions,
	Collapse,
	Card,
	Badge,
	Anchor,
	Tooltip,
	InputNumber,
	Alert,
	Tree,
	Result,
	TreeSelect,
	Rate,
	Transfer
} from 'ant-design-vue';

import AskAction from '../components/common/AskAction.vue';
import EditDrawer from '../components/common/EditDrawer.vue';
import SelectTime from '../components/common/SelectTime.vue';
import SelectOperator from '../components/common/SelectOperator.vue';
import SelectOrgByName from '../components/common/SelectOrgByName.vue';
import SelectStationByName from '../components/common/SelectStationByName.vue';
import SimpleImageEmpty from '../components/common/SimpleImageEmpty.vue';
import ServiceVersionTip from '../components/common/ServiceVersionTip.vue';
import MyRadioButton from '../components/common/MyRadioButton.vue';
import MyCheckButton from '../components/common/MyCheckButton.vue';
import MyCheckBox from '../components/common/MyCheckBox.vue';
import MySelect from '../components/common/MySelect.vue';
import MyConfirm from '../components/common/MyConfirm.vue';
import UploadResultModal from '../components/modal/UploadResultModal.vue';
Vue.component('AskAction', AskAction);
Vue.component('EditDrawer', EditDrawer);
Vue.component('SelectTime', SelectTime);
Vue.component('SelectOperator', SelectOperator);
Vue.component('SelectOrgByName', SelectOrgByName);
Vue.component('SelectStationByName', SelectStationByName);
Vue.component('SimpleImageEmpty', SimpleImageEmpty);
Vue.component('ServiceVersionTip', ServiceVersionTip);
Vue.component('MyRadioButton', MyRadioButton);
Vue.component('MyCheckButton', MyCheckButton);
Vue.component('MyCheckBox', MyCheckBox);
Vue.component('MySelect', MySelect);
Vue.component('MyConfirm', MyConfirm);
Vue.component('UploadResultModal', UploadResultModal);

Spin.setDefaultIndicator({
	indicator: (h) => {
		return <a-icon type="loading" style="font-size: 24px;" spin />;
	},
});


Vue.use(Alert);
Vue.use(Tree);
Vue.use(InputNumber);
Vue.use(Tooltip);
Vue.use(Anchor);
Vue.use(Badge);
Vue.use(Card);
Vue.use(Collapse);
Vue.use(Descriptions);
Vue.use(Empty);
Vue.use(List);
Vue.use(Popover);
Vue.use(Statistic);
Vue.use(Tabs);
Vue.use(Timeline);
Vue.use(Modal);
Vue.use(Popconfirm);
Vue.use(Progress);
Vue.use(TimePicker);
Vue.use(Upload);
Vue.use(Button);
Vue.use(Layout);
Vue.use(Row);
Vue.use(Col);
Vue.use(Menu);
Vue.use(Icon);
Vue.use(Breadcrumb);
Vue.use(Table);
Vue.use(Pagination);
Vue.use(Tag);
Vue.use(Divider);
Vue.use(ConfigProvider);
Vue.use(DatePicker);
Vue.use(Skeleton);
Vue.use(FormModel);
Vue.use(Input);
Vue.use(Select);
Vue.use(Switch);
Vue.use(Checkbox);
Vue.use(Radio);
Vue.use(BackTop);
Vue.use(Avatar);
Vue.use(Dropdown);
Vue.use(Form);
Vue.use(Drawer);
Vue.use(Slider);
Vue.use(Cascader);
Vue.use(Spin);
Vue.use(Steps);
Vue.use(Result);
Vue.use(TreeSelect);
Vue.use(Rate);
Vue.use(Transfer);

Vue.prototype.$message = message;
Vue.prototype.$notification = notification;
Vue.prototype.$confirm = Modal.confirm;
Vue.prototype.$info = Modal.info;
Vue.prototype.$warning = Modal.warning;
Vue.prototype.$error = Modal.error;
